<ng-container *transloco="let t">
  @let restrictionLabels = labels();
  @let shippingNames =
    restrictionLabels.shipping ? formatNames(restrictionLabels.shipping, t('global.or')) : null;
  @let paymentNames =
    restrictionLabels.payment ? formatNames(restrictionLabels.payment, t('global.or')) : null;
  @if (shippingNames || paymentNames) {
    @if (compact()) {
      <p class="restriction-meta">
        @if (shippingNames && paymentNames) {
          <pxw-icon icon="info" size="xs" />
          {{ t('productRestriction.withConditions') }}
        } @else if (shippingNames) {
          <pxw-icon icon="shipping" size="xs" />
          {{ t('productRestriction.onlyShipping', { names: shippingNames }) }}
        } @else {
          <pxw-icon icon="payment" size="xs" />
          {{ t('productRestriction.onlyPayment', { names: paymentNames }) }}
        }
      </p>
    } @else {
      <div class="restriction-detail">
        @if (shippingNames) {
          <span>{{ t('productRestriction.detailShipping', { names: shippingNames }) }}</span>
        }
        @if (paymentNames) {
          <span>{{ t('productRestriction.detailPayment', { names: paymentNames }) }}</span>
        }
      </div>
    }
  }
</ng-container>
